import React, { useEffect, useState } from 'react';
import CommonIcon from '../../helpers/icons';
import $ from "jquery";
import axios from 'axios';
import API from '../../helpers/endpointservice';
import { logoutFunction } from '../../custom/logoutFunction';
import swal from "sweetalert";
import { toast } from "react-toastify";
import LoaderVisible from '../../helpers/loader';

function CommonCloneModal({isMobile, roleId, cloneSuccess, isCourse}) {

    const userId = localStorage.getItem('UserId');
    const [isFieldEmpty, setIsFieldEmpty] = useState(false);
    const [isDuplicateRole, setIsDuplicateRole] = useState(false);
    const [roleName, setRoleName] = useState("");
    const [isLoader, setIsLoader] = useState(false);

    useEffect(() => {

    }, [])

    const cloneCancel = () => {
        setIsFieldEmpty(false);
        setRoleName("");
        setIsDuplicateRole(false);
        handleCloseModal();
    }

    const cloneRole = () => {
       if(roleName !== ""){
        setIsFieldEmpty(false);
        checkDuplicate();
       }else {
        setIsFieldEmpty(true);
       }
    }
    
    const handleCloseModal = () => {
      $("#cloneRolesModal").removeClass("show");
      $("body").removeClass("scrollhide");
    }

    const checkDuplicate = () => {
        setIsLoader(true);
        let obj = {
            "name": roleName
        }
        let apiUrl = "";
        if(isCourse == true) {
          apiUrl = API.CHECKCOURSE_DUPLICATE;
        }else {
          apiUrl = API.CHECKMAINROLE_DUPLICATE;
        }
        axios({
            method: "POST",
            url: apiUrl,
            data: obj
          })
            .then((res) => {
              if (res.status === 200) {
                if(res?.data == false){
                   setIsDuplicateRole(false);
                   cloneRoleAPI();
                }else{
                   setIsDuplicateRole(true);
                   setIsLoader(false);
                }
              }
            })
            .catch((error) => {
              setIsLoader(false);
              logoutFunction(error?.response?.status);
              swal("Error!", "Something went wrong. Please try again.", "warning");
        });
    }

    const cloneRoleAPI = () => {
        let obj = {
            "id": roleId,
            "name": roleName
        }
        let apiUrl = "";
        if(isCourse == true){
          apiUrl = API.CLONE_COURSE + "?userId=" + userId;
        }else {
          apiUrl = API.CLONE_ALLROLES + "?userId=" + userId;
        }
        axios({
            method: "POST",
            url: apiUrl,
            data: obj
          })
            .then((res) => {
              if (res.status === 200) {
                cloneCancel();
                cloneSuccess();
                let toastMessage = "";
                if(isCourse == true){
                   toastMessage = "Course cloned successfully";
                }else {
                  toastMessage = "Role cloned successfully";
                }
                toast.success(toastMessage, {
                    position: toast.POSITION.TOP_RIGHT,
                    color: "#fff",
                });
                setIsLoader(false);
              }else {
                setIsLoader(false);
              }
            })
            .catch((error) => {
              setIsLoader(false);
              logoutFunction(error?.response?.status);
              swal("Error!", "Something went wrong. Please try again.", "warning");
        });
    }

    return (<>
        <div
        className="offcanvas offcanvas-end offcanvasStyle"
        tabIndex={-1}
        data-bs-scroll="false"
        data-bs-backdrop="false"
        id="cloneRolesModal"
        aria-labelledby="offcanvasScrollingLabel"
        >
        <div
          className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"
            }`}
        >
          <h6 id="offcanvasRightLabel" className="modal-title fw-600">
            {"Clone"}
          </h6>
          <button
            className={`text-reset offcavasclose buttonstyle background-white ${isMobile ? "pr-0" : "pr-0"
              }`}
              onClick={() => handleCloseModal()}
            // data-bs-dismiss="offcanvas"
          >
            <CommonIcon fileName="CrossIcon" />
          </button>
          <button
          className="display-none"
              id="closeButton"
            data-bs-dismiss="offcanvas"
          >
          </button>
        </div>
        <div className="offcanvas-body px-4 pt-0">
              <div className="row">
                <div className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 mb-2`}>
                  <div className="form-group">
                    <label className={`label-text  ${isMobile ? "d-flex pt-2 mb-2-ledger" : "d-flex mb-2-ledger mb-1"}`}>
                      <CommonIcon fileName={isCourse == true ? "CourseCodeIcon" : "supportingIcon"} />
                      <span className="pl-10 properties-search-span">{isCourse == true ? "Course code" : "Role"}</span>
                    </label>
                    <input className={` form-control border-radius mt-2 font-size-12`}
                      onChange={(e) => {setRoleName(e.target.value)}}
                      style={{ borderColor: isFieldEmpty || isDuplicateRole ? "#d12232" : "" }}
                      value={roleName} 
                    />
                    {isFieldEmpty ? (
                      <span className="send-rework-label">This field is required</span>
                     ) : (<></>)}
                     {isDuplicateRole ? (
                      <span className="send-rework-label">{isCourse ? "This course code has been already exist" : "This role has been already exist" }</span>
                     ) : (<></>)}
                  </div>
                </div>
              </div>
              <div className="d-flex col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
                  <button className="btn rejectbutton" onClick={() => cloneCancel()} >
                  <CommonIcon className="button-img" fileName="ButtonRejectApprovalIcon" />
                  <span className="px-1">Cancel</span> </button>
                <button
                className={`btn approvebutton d-flex gap-1 mx-2`}
                onClick={() => cloneRole()}>
                   <span><CommonIcon fileName="ButtonSubmitIcon" /></span>
                <span className="model-label pl-vendor3 pl-2">Clone</span>
              </button>
              </div>
            </div>
      </div>
      <LoaderVisible
      isLoader={isLoader}
      />
    </>)
};

export default CommonCloneModal;